<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <tbody>
                        <tr v-for="(user, index) in users" v-if="!loading">
                            <td>
                                {{ user.fullname }}
                                <input type="hidden" :name="'users[' + index + '][id]'" v-model="user.id">
                                <input type="hidden" :name="'users[' + index + '][fullname]'" v-model="user.fullname">
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="2" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="2">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." onkeydown="return event.key != 'Enter';" class="form-control" id="userSearchInput" type="text" v-model="user">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'user-seletor',
        props: ['route', 'oldUsers', 'exclude'],
        data() {
            return {
                loading: true,
                user: null,
                users: []
            };
        },
        methods : {
            addRow: function (user) {
                if (this.getCurrentSelectedUsersId().includes(user.id) == false && (this.exclude == undefined || (this.exclude != undefined && this.exclude != user.id))) {
                    this.users.push({
                        id: user.id,
                        fullname: user.fullname
                    })
                }
            },
            deleteRow: function (index) {
                this.users.splice(index, 1)
            },
            getCurrentSelectedUsersId: function() {
                return this.users.map(user => user.id);
            }
        },
        mounted(){
            $("#userSearchInput").autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedUsersId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : ''), 'under_contract' : 1 },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.fullname,
                                    value: item.fullname
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.fullname}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.user = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item)
                        $(e.target).val("")
                        this.user = null
                    }
                }
            }).focus(() => {
                $("#userSearchInput").autocomplete("search", '');
            });

            const jsonUserBackup = JSON.parse(this.oldUsers)
            if (Array.isArray(jsonUserBackup)) {
                if (jsonUserBackup.length > 0) {
                    jsonUserBackup.forEach(user => {
                        this.addRow(user)
                    })
                }
            }
            this.loading = false
        }
    }
</script>
